import React from 'react';
import {Observable} from 'rxjs';
import {isPsychotherapyOfferRequired, Referral} from '../../referral';
import {HoursInput} from "./HoursInput";
import pluralize from "pluralize";

type PsychotherapySectionProps = {
    referral: Referral;
    isSubmitting$: Observable<boolean>;
};
export const PsychotherapySection = ({
                                         referral,
                                         isSubmitting$,
                                     }: PsychotherapySectionProps
) => {

    if (!isPsychotherapyOfferRequired(referral)) {
        return null;
    }

    return (
        <>
            <div className="flex">
                <HoursInput maxValue={maxOffer(referral)}
                            recommendedHoursLabel={(maxHours) => {
                                return `(${maxHours} ${pluralize(referral.authTherapyTreatmentUnitType, maxHours)} per ${referral.authTherapyTreatmentUnitsPer} recommended)`
                            }}
                            name='psychotherapyOffer'
                            label='Offer'
                            twoDecimalSupport={true}
                            isRequired={true}
                            width='32em'
                            isSubmitting$={isSubmitting$}/>
            </div>
        </>
    );
};

const maxOffer = (referral: Referral) => referral.authTherapyTreatmentUnit;